import {
  type ChartAggregateFunctionType,
  createAliasForAggregation,
} from '@blaze-shared/elements-domain';

import { type ChartPropsModelData } from '../chart.models';
import { type MultiSeries } from '../models/helper.types';

export function getChartAliasForMainValue(
  dataAlias: ChartPropsModelData['alias'] | undefined,
  mainValueColumnName: string | undefined,
  aggregation: ChartAggregateFunctionType | undefined,
): { aliasMap: Record<string, string>; mainAlias: string } {
  const aliasMap: Record<string, string> = {};
  // Check if the alias is a default alias (Series #0, Series #1, etc.)
  const isDefaultAlias =
    createAliasForAggregation({ alias: undefined }, 0, undefined, undefined) === dataAlias;
  // If the alias is not a default alias, we need to create a mapping for it
  aliasMap[createAliasForAggregation({ alias: dataAlias }, 0, undefined, undefined)] =
    createAliasForAggregation(
      isDefaultAlias ? {} : { alias: dataAlias },
      0,
      mainValueColumnName,
      aggregation,
    );
  const mainAlias = createAliasForAggregation({ alias: dataAlias }, 0, undefined, undefined);
  return { aliasMap, mainAlias };
}

export function fillAliasInMultiSeries(
  multiSeries: MultiSeries[] | undefined,
  aliasMap = {} as Record<string, string>,
  columnNameMap = {} as Record<string, string>,
): MultiSeries[] | undefined {
  return multiSeries
    ?.map((series, index) => {
      series.alias = createAliasForAggregation(series, index + 1, undefined, undefined);
      const isDefaultAlias =
        createAliasForAggregation({ alias: undefined }, index + 1, undefined, undefined) ===
        series?.alias;
      aliasMap[series.alias] = createAliasForAggregation(
        isDefaultAlias ? {} : series,
        index + 1,
        (series.mainValue && columnNameMap[series.mainValue]) || undefined,
        series.aggregation,
      );
      return series;
    })
    .filter((v) => v.aggregation);
}
